// extracted by mini-css-extract-plugin
export default {"card":"SingleAnimal_card__d7jGB","header":"SingleAnimal_header__-NpL0","btn":"SingleAnimal_btn__dvB4r","btns":"SingleAnimal_btns__xfS5u"};